export default {
      id: "new-alert-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "sprite.svg#new-alert",
      toString: function () {
        return this.url;
      }
    }